import { render, staticRenderFns } from "./ZSplitButtonDropdown.vue?vue&type=template&id=8c63765e"
import script from "./ZSplitButtonDropdown.vue?vue&type=script&lang=ts"
export * from "./ZSplitButtonDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ZDivider: require('/app/components/zeal/ZDivider/ZDivider.vue').default,ZMenu: require('/app/components/zeal/ZMenu/ZMenu.vue').default})
